import { render, staticRenderFns } from "./DevelopersHome.vue?vue&type=template&id=bdf8b6a2&"
import script from "./DevelopersHome.vue?vue&type=script&lang=js&"
export * from "./DevelopersHome.vue?vue&type=script&lang=js&"
import style0 from "./DevelopersHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports